module.exports = __webpack_public_path__ + "static/img/gate_c.39b17c4f.png";